import React, { useId } from "react";
import type { AiSparkleIconProps } from "./AiSparkleIcon.types";

/**
 * Gradient AI sparkle star (Figma "Logo" glyph) — used as the badge on the
 * AI-edit trigger and as a menu-item icon. Gradient/clip ids are generated
 * per instance via useId so multiple sparkles on one page never collide.
 */
export const AiSparkleIcon: React.FC<AiSparkleIconProps> = ({ size = 12 }) => {
  const uid = useId();
  const clipId = `ai-sparkle-clip-${uid}`;
  const gradAId = `ai-sparkle-grad-a-${uid}`;
  const gradBId = `ai-sparkle-grad-b-${uid}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 6 6"
      fill="none"
      aria-hidden
    >
      <g clipPath={`url(#${clipId})`}>
        <g transform="matrix(-0.00180237 -0.00142367 0.000861311 -0.00297917 3.61323 2.16188)">
          <rect
            x="0"
            y="0"
            width="1432.73"
            height="1150.12"
            fill={`url(#${gradAId})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1432.73"
            height="1150.12"
            transform="scale(1 -1)"
            fill={`url(#${gradAId})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1432.73"
            height="1150.12"
            transform="scale(-1 1)"
            fill={`url(#${gradAId})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1432.73"
            height="1150.12"
            transform="scale(-1)"
            fill={`url(#${gradAId})`}
            opacity="1"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <path
        d="M4.15268 1.47381C3.7916 1.13384 3.54445 0.540166 3.4218 0C3.29896 0.540276 3.05207 1.13407 2.69086 1.47404C2.32978 1.81377 1.69881 2.04638 1.125 2.16205C1.69904 2.27749 2.32989 2.50996 2.69098 2.84995C3.05206 3.18979 3.29921 3.78359 3.42205 4.32375C3.5447 3.78348 3.79178 3.18968 4.1528 2.84971C4.51389 2.50987 5.14485 2.27737 5.71866 2.1617C5.14475 2.04626 4.5139 1.81366 4.15268 1.47381Z"
        fill={`url(#${gradAId})`}
      />
      <path
        d="M2.18377 4.25548C1.96824 4.05252 1.82035 3.69767 1.74707 3.375C1.67367 3.69767 1.52628 4.05251 1.31051 4.25559C1.09474 4.45845 0.717773 4.59751 0.375 4.6666C0.717891 4.73567 1.09474 4.87452 1.31051 5.0776C1.52628 5.28056 1.67394 5.63541 1.74732 5.95807C1.82058 5.63528 1.96824 5.28056 2.18388 5.07749C2.39953 4.87452 2.77655 4.73555 3.11927 4.66636C2.77657 4.5974 2.39955 4.45845 2.18377 4.25548Z"
        fill={`url(#${gradBId})`}
      />
      <defs>
        <clipPath id={clipId}>
          <path d="M4.15268 1.47381C3.7916 1.13384 3.54445 0.540166 3.4218 0C3.29896 0.540276 3.05207 1.13407 2.69086 1.47404C2.32978 1.81377 1.69881 2.04638 1.125 2.16205C1.69904 2.27749 2.32989 2.50996 2.69098 2.84995C3.05206 3.18979 3.29921 3.78359 3.42205 4.32375C3.5447 3.78348 3.79178 3.18968 4.1528 2.84971C4.51389 2.50987 5.14485 2.27737 5.71866 2.1617C5.14475 2.04626 4.5139 1.81366 4.15268 1.47381Z" />
        </clipPath>
        <linearGradient
          id={gradAId}
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AA97D8" />
          <stop offset="1" stopColor="#6442B3" />
        </linearGradient>
        <radialGradient
          id={gradBId}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-1.07674 -0.850524 0.51455 -1.7798 1.86148 4.66654)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4B3286" />
          <stop offset="1" stopColor="#18102B" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default AiSparkleIcon;
